/* Modal popup: trigger, frequency, reopen tab, copy code, events */
(() => {
  const D = document;
  const $ = (s, r = D) => r.querySelector(s);
  const mobile = matchMedia('(max-width:749px)');
  const design = window.Shopify && Shopify.designMode;
  const wrapOf = (el) => el.closest && el.closest('[data-modal-popup]');
  const deviceOk = (w) => w.dataset.device === 'all' || (w.dataset.device === 'mobile') === mobile.matches;
  const emit = (name, id) => D.dispatchEvent(new CustomEvent('modal-popup:' + name, { detail: { id } }));

  const open = (w) => {
    const dialog = $('dialog', w);
    if (dialog.open) return;
    dialog.showModal();
    const tab = $('.modal-popup__tab', w);
    if (tab) tab.hidden = true;
    emit('open', dialog.id);
  };

  /* Delegated handlers, registered once (the editor re-runs this file on section reload) */
  if (!window.modalPopupReady) {
    window.modalPopupReady = true;

    D.addEventListener('click', (e) => {
      const w = wrapOf(e.target);
      if (w) {
        const dialog = $('dialog', w);
        if (e.target === dialog || e.target.closest('[data-popup-close]')) dialog.close();
        if (e.target.closest('.modal-popup__tab')) open(w);
        const copy = e.target.closest('[data-copy-code]');
        if (copy) {
          const label = $('span', copy);
          const text = label.textContent;
          navigator.clipboard.writeText(copy.dataset.copyCode).then(() => {
            label.textContent = copy.dataset.copied;
            setTimeout(() => (label.textContent = text), 1800);
          });
        }
      }
      const link = e.target.closest('a[href^="#modal-popup-"]');
      const target = link && D.getElementById(link.getAttribute('href').slice(1));
      if (target && wrapOf(target)) {
        e.preventDefault();
        open(wrapOf(target));
      }
    });

    D.addEventListener('close', (e) => {
      const w = wrapOf(e.target);
      if (!w) return;
      const tab = $('.modal-popup__tab', w);
      if (tab && deviceOk(w)) tab.hidden = false;
      emit('close', e.target.id);
    }, true);

    D.addEventListener('theme:drawer:open', () => {
      D.querySelectorAll('.modal-popup__dialog[open]').forEach((d) => d.close());
    });

    if (design) {
      D.addEventListener('shopify:block:select', (e) => {
        const w = wrapOf(e.target);
        if (w) open(w);
      });
      D.addEventListener('shopify:block:deselect', (e) => {
        const w = wrapOf(e.target);
        if (w) $('dialog', w).close();
      });
    }
  }

  if (design) return;

  D.querySelectorAll('[data-modal-popup]').forEach((w) => {
    if (!deviceOk(w)) return;
    const dialog = $('dialog', w);
    const tab = $('.modal-popup__tab', w);
    const o = w.dataset;
    const key = 'modal-popup:' + o.key + (o.scope === 'page' ? ':' + location.pathname : '');
    const session = o.scope === 'session';
    const store = session ? sessionStorage : localStorage;
    let seen;
    try { seen = JSON.parse(store.getItem(key)); } catch (e) {}
    if (tab && seen) tab.hidden = false;

    const auto = () => {
      if (dialog.open || $('.drawer.is-open')) return;
      if (!$('.has-success, .has-error', dialog)) {
        const now = Date.now();
        const days = +o.days;
        if (session) {
          if (seen) return;
          seen = { start: now, count: 0 };
        } else if (days) {
          if (!seen || now - seen.start > days * 864e5) seen = { start: now, count: 0 };
          if (seen.count >= +o.max) return;
        } else seen = seen || { start: now, count: 0 };
        seen.count++;
        try { store.setItem(key, JSON.stringify(seen)); } catch (e) {}
      }
      open(w);
    };
    const onExit = (e) => {
      if (e.relatedTarget || e.clientY > 0) return;
      D.removeEventListener('mouseout', onExit);
      auto();
    };
    const start = () => {
      dialog.querySelectorAll('img[loading]').forEach((img) => (img.loading = 'eager'));
      if ($('.has-success, .has-error', dialog)) auto();
      else if (o.trigger === 'delay') setTimeout(auto, o.delay * 1000);
      else if (o.trigger === 'exit' && !mobile.matches) D.addEventListener('mouseout', onExit);
    };
    const idle = () => (window.requestIdleCallback || setTimeout)(start);
    D.readyState === 'complete' ? idle() : addEventListener('load', idle);
  });
})();